'use strict'

/**
 *
 * @name: nnRollOutSection
 *
 */

import DirectiveTemplate from './nn-roll-out-section.directive.html'
import './nn-roll-out-section.directive.scss'
import scrollToElement from 'scroll-to-element'

function nDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      visiblePart: '=*',
      isCollapsePart: '=*',
      isInitiallyCollapsed: '=*',
      uuid: '=*'
    },
    transclude: true,
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $element, $rootScope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  let collapseEl = null
  let scrollToEl = null
  let mHeight = 0

  $scope.isCollapsed = $scope.isInitiallyCollapsed === undefined ? true : $scope.isInitiallyCollapsed


  /*
   *
   * @PUBLIC
   *
   */

  $scope.toggleCollapse = () => {
    if ($scope.isCollapsed) {
      expand()
    } else {
      collapse()
    }
    $rootScope.$emit('nn-roll-out-section/on-button-click')
  }

  /*
   *
   * @PRIVATE
   *
   */

  function expand () {
    mHeight = measureHeight(collapseEl)

    setTimeout(() => {
      collapseEl.style.height = mHeight + 'px'
      $scope.isCollapsed = false
    });
  }

  function collapse () {
    mHeight = measureHeight(collapseEl)
    collapseEl.style.height = mHeight + 'px'

    setTimeout(() => {
      collapseEl.style.height = 0
      setTimeout(() => {
        $scope.isCollapsed = true
      });

      if (scrollToEl) {
        scrollToElement(scrollToEl, {
          offset: window.outerWidth > 801 ? -220 : -170,
          duration: 500,
        })
      }
    }, 0)
  }

  function measureHeight (el) {
    el.style.position = 'absolute'
    el.style.display = 'block'
    el.style.height = 'auto'
    el.style.visibility = 'hidden'

    const h = el.clientHeight

    el.style.position = null
    el.style.display = null
    el.style.height = '0px'
    el.style.visibility = null

    return h
  }

  function applyInitialStyles (el) {
    el.style.transition = 'height 0.5s'

    if ($scope.isInitiallyCollapsed) {
      el.style.height = '0px'
    } else {
      el.style.height = 'auto'
    }
  }

  function getCollapseEl () {
    return $element[0].querySelector('[data-roll-out-section-collapsed]')
  }

  function setAutoHeight () {
    collapseEl.style.height = 'auto'
  }

  function getScrollToEl () {
    return document.getElementById('js-roll-out-scroll-to')
  }

  /*
   *
   * @INIT
   *
   */

  const interval = setInterval(() => {
    collapseEl = getCollapseEl()
    scrollToEl = getScrollToEl()

    if (collapseEl) {
      clearInterval(interval)
      applyInitialStyles(collapseEl)
    }
  }, 300);


  window.addEventListener('resize', setAutoHeight)
  window.addEventListener('orientationchange', setAutoHeight)

  $scope.$on('$destroy', function () {
    window.removeEventListener('resize', setAutoHeight)
    window.removeEventListener('orientationchange', setAutoHeight)
  })

  $rootScope.$on('nn-roll-out-section/open' + $scope.uuid, () => {
    if (!$scope.isCollapsed) return
    expand()
  })
}

export default nDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-roll-out-section/nn-roll-out-section.directive.js